import CloseIcon from '@mui/icons-material/Close'
import { Box, IconButton, Modal, SxProps, Typography } from '@mui/material'
import React from 'react'

interface IProps {
  open: boolean
  handleClose: () => void
  children?: string | JSX.Element | JSX.Element[]
  title?: string
  maxWidth?: string
  minWidth?: string
  fullHeight?: boolean
  sx?: SxProps
  disableEscapeKeyDown?: boolean
}

export default function (props: IProps) {
  const { open, handleClose, children, title, maxWidth, fullHeight, sx, disableEscapeKeyDown, minWidth } = props

  return (
    <Modal
      disableEscapeKeyDown={disableEscapeKeyDown}
      open={open}
      onClose={handleClose}
      aria-labelledby="modal-modal-title"
      aria-describedby="modal-modal-description"
      sx={{
        ...sx,
        display: 'flex',
        alignItems: 'center',
      }}
    >
      <Box
        sx={{
          overflow: 'hidden auto',
          display: 'flex',
          flexDirection: 'column',
          maxHeight: '100%',
          maxWidth: maxWidth || '420px',
          minWidth: minWidth || '320px',
          width: '100%',
          marginX: 'auto',
          outline: 'none',
          borderRadius: '12px',
        }}
      >
        <Box
          position="relative"
          bgcolor="white"
          borderRadius="12px"
          display="flex"
          flexDirection="column"
          pt={fullHeight ? 0 : 2}
          px={fullHeight ? 0 : 2.5}
          pb={fullHeight ? 0 : 3.5}
        >
          {!disableEscapeKeyDown && (
            <Box
              display="flex"
              alignItems="center"
              sx={{ position: 'absolute', zIndex: 100, top: '20px', right: '20px' }}
            >
              <IconButton
                aria-label="Close modal"
                onClick={handleClose}
                sx={{ width: '18px', minWidth: 'auto', height: '18px', padding: 0 }}
              >
                <CloseIcon style={{ width: '18px', height: '18px', fill: '#bcc1b9' }} />
              </IconButton>
            </Box>
          )}

          <Typography
            variant="h2"
            mb={fullHeight ? 0 : 3}
            sx={{
              textAlign: 'center',
              fontFamily: 'Manrope',
              fontWeight: 700,
              color: '#212122',
            }}
          >
            {title}
          </Typography>
          {children}
        </Box>
      </Box>
    </Modal>
  )
}
